<style lang="scss" src='./ChangePassword.scss' scoped></style>
<template src="./ChangePassword.html"></template>

<script>
import GwPassword from '@/components/gwPassword/GwPassword.vue';
import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, password } from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import { changePassword } from '@/api/index';

extend('required', required);

export default {
  name: 'ChangePassword',
  components: {
    ValidationProvider,
    ValidationObserver,
    GwPassword,
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      confirmationPassword: null,
      loading: false,
    };
  },
  computed: {
    ...mapState('Settings', ['currentTab']),
    passwordIsValid (){
      
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).{8,}$/;    
      return regex.test(this.newPassword);
    
    },
  },
  watch: {
    currentTab: function (val) {
      this.reset();
    },
  },
  methods: {
    reset() {
      this.currentPassword = null;
      this.newPassword = null;
      this.confirmationPassword = null;
      this.$refs.validator.reset();
      this.loading = false;
    },

    async changePassword () {
      const validForm = await this.$refs.validator.validate().then((v) => v);
      if (validForm) {
        this.loading = true;
        await changePassword(this.currentPassword, this.newPassword)
            .then((response) => {
                Vue.notify({ type: 'success', text: this.$t('settings.passwordUpdated') });
                this.reset();
            }).catch((err) => {
              this.loading = false;
            });
      }
    },
  },
  beforeCreate() {
    extend('password', {
      params: ['target'],
      validate(value, { target }) {
        return value === target;
      },
      message: this.$t('login.passwordNotMatch')
    });
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Change Password");
      this.$analytics.logEvent("web_settings_change_password");
    }
  },
};

</script>
